export default Object.freeze({
  Success: 1,
  Error: 2,
  Warning: 3,
  Information: 4,
  Reminder: 5,
});
